if (document.querySelectorAll(".dashboard-index").length) {
  var donutContainer = $("#donut_container")

  if (donutContainer.length > 0) {
    var colorArray = ["#c8e4ce", "#7bb5eb", "#7794b9", "#66664D", "#E666FF", "#4DB3FF", "#1AB399", "#E666B3", "#33991A", "#CC9999", "#B3B31A", "#00E680", "#4D8066", "#809980", "#E6FF80", "#1AFF33", "#999933", "#FF3380", "#CCCC00", "#66E64D", "#4D80CC", "#9900B3", "#FF6633", "#FFB399", "#FF33FF", "#FFFF99", "#00B3E6", "#E64D66", "#4DB380", "#FF4D4D", "#99E6E6", "#6666FF", "#E6B333", "#3366E6", "#999966", "#99FF99", "#B34D4D", "#80B300", "#809900", "#E6B3B3", "#6680B3", "#66991A", "#FF99E6", "#CCFF1A", "#FF1A66", "#E6331A", "#33FFCC", "#66994D", "#B366CC", "#4D8000", "#B33300", "#CC80CC"]
    $.getJSON(donutContainer.data("url"), function(data) {
      var monthsGen, monthsRecs, stateRecs, sysRecs

      if (data !== null && data.states_rec_quantities.length > 0) {
        $("#processing-animation").hide()
        $("#credit-generation-charts").show()
        stateRecs = $("#all-recs")
        new Chart(stateRecs, {
          type: "doughnut",
          data: {
            labels: data.states,
            datasets: [
              {
                label: "# of Recs",
                data: data.states_rec_quantities,
                backgroundColor: colorArray
              }
            ]
          },
          options: {
            animation: false,
            maintainAspectRatio: false,
            cutout: "80%",
            plugins: {
              tooltip: {
                backgroundColor: "rgba(251, 232, 170, .8)",
                xPadding: 16,
                yPadding: 16,
                titleFontSize: 16,
                titleColor: "#3598db",
                bodyColor: "black",
                bodyFontSize: 14,
                cornerRadius: 8,
                displayColors: false
              },
              legend: {
                display: false
              }
            }
          }
        })

        sysRecs = $("#recs-by-system")
        new Chart(sysRecs, {
          type: "bar",
          data: {
            labels: data.systems,
            datasets: [
              {
                label: "recs per system",
                data: data.systems_rec_quanities,
                backgroundColor: "rgb(124, 181, 236)"
              }
            ]
          },
          options: {
            animation: false,
            maintainAspectRatio: false,
            ticks: {
              precision: 0
            },
            plugins: {
              tooltip: {
                backgroundColor: "rgba(251, 232, 170, .8)",
                xPadding: 16,
                yPadding: 16,
                titleSize: 16,
                titleColor: "#3598db",
                bodyColor: "black",
                bodySize: 14,
                cornerRadius: 8,
                displayColors: true
              },
              legend: {
                display: false
              }
            }
          }
        })

        monthsRecs = $("#recs-by-month")
        new Chart(monthsRecs, {
          type: "bar",
          data: {
            labels: data.months,
            datasets: [
              {
                label: "recs per month",
                data: data.months_rec_quanities,
                barThickness: 10,
                barPercentage: 0.8,
                categoryPercentage: 0.8,
                backgroundColor: "rgb(124, 181, 236)"
              }
            ]
          },
          options: {
            animation: false,
            maintainAspectRatio: false,
            ticks: {
              precision: 0
            },
            plugins: {
              tooltip: {
                backgroundColor: "rgba(251, 232, 170, .8)",
                xPadding: 16,
                yPadding: 16,
                titleFontSize: 16,
                titleColor: "#3598db",
                bodyColor: "black",
                bodyFontSize: 14,
                cornerRadius: 8,
                displayColors: true
              },
              legend: {
                display: false
              }
            },
            fill: false
          }
        })

        monthsGen = $("#gen-by-month")
        new Chart(monthsGen, {
          type: "bar",
          data: {
            labels: data.gen_months,
            datasets: [
              {
                label: "kWh per month",
                data: data.gen_amounts,
                barThickness: 8,
                barPercentage: 0.8,
                categoryPercentage: 0.8,
                backgroundColor: "rgb(124, 181, 236)"
              }
            ]
          },
          options: {
            animation: false,
            maintainAspectRatio: false,
            ticks: {
              precision: 0
            },
            plugins: {
              tooltip: {
                backgroundColor: "rgba(251, 232, 170, .8)",
                xPadding: 16,
                yPadding: 16,
                titleFontSize: 16,
                titleColor: "#3598db",
                bodyColor: "black",
                bodyFontSize: 14,
                cornerRadius: 8,
                displayColors: true
              },
              legend: {
                display: false
              }
            },
            fill: false
          }
        })
      } else {
        $("#no-generation-found").removeClass("hidden")
        $("#processing-animation").hide()
        return $("#credit-generation-charts").hide()
      }
    })
  }
}
